export enum MaxPageData {
  DATA_SIZE = 8,
}
